<template>
  <list
    :heading="heading"
    :description="description"
    model="hair-color"
    :items="hairColors"
    :status="status"
    :nextUrl="nextUrl"
    :displayStyle="displayStyle"
    @onFetchMore="FETCH_MORE"
  >
    <template #filter>
      <p>Total: {{ total }} {{ plural("color", total) }}</p>
      <ViewToggle
        :displayStyle="displayStyle"
        @toggled="CHANGE_DISPLAY_STYLE"
      />
      <div class="button-holder sort-list">
        <SortToggle
          field="name"
          :activeField="sort.field"
          :direction="sort.direction"
          buttonLabel="Color Name"
          @sorted="SORT"
        />
        <SortToggle
          field="color_family"
          :activeField="sort.field"
          :direction="sort.direction"
          buttonLabel="Color Family"
          @sorted="SORT"
        />
        <SortToggle
          field="num_ponies"
          :activeField="sort.field"
          :direction="sort.direction"
          buttonLabel="Number Ponies"
          @sorted="SORT"
        />
      </div>
    </template>
    <template #list>
      <ul class="item-list">
        <ItemListHeader>
          <span>Name:</span>
          <span>Color Family:</span>
          <span>Number Ponies:</span>
        </ItemListHeader>
        <ListItem
          :key="item.id"
          v-for="item in hairColors"
          :user="user"
          :item="item"
          @onRemove="REMOVE"
          model="hair-color"
        >
          <span
            ><router-link :to="`/hair-color/${item.slug}`">{{
              item.name
            }}</router-link></span
          >
          <span>{{ item.color_family }}</span>
          <span
            >{{ item.num_ponies }} {{ plural("Pony", item.num_ponies) }}</span
          >
        </ListItem>
      </ul>
    </template>
    <HairColorCard
      :key="item.id"
      v-for="item in hairColors"
      :user="user"
      :item="item"
      @onRemove="REMOVE"
    />
  </list>
</template>

<script>
import { num } from "../../data/config";
import { plural } from "../../utils/helpers";
import { mapActions, mapGetters, mapState } from "vuex";
import List from "../../layouts/List/List";
import HairColorCard from "../../components/HairColorCard/HairColorCard";
import ViewToggle from "../../components/ViewToggle/ViewToggle";
import ListItem from "../../components/ListItem/ListItem";
import SortToggle from "../../components/SortToggle/SortToggle";
import ItemListHeader from "../../components/ItemListHeader/ItemListHeader";

export default {
  name: "HairColorList",
  data() {
    return {
      errors: [],
    };
  },
  components: {
    HairColorCard,
    ItemListHeader,
    List,
    ListItem,
    SortToggle,
    ViewToggle,
  },
  mounted() {
    if (this.hairColors && this.hairColors.length < this.total) {
      this.FETCH_ALL({ num });
    } else if (!this.total) {
      this.FETCH_ALL({ num });
    }
  },
  computed: {
    ...mapGetters("hairColor", { hairColors: "getAll" }),
    ...mapState({
      user: (state) => state.currentUser.currentUser,
      heading: (state) => state.hairColor.heading,
      description: (state) => state.hairColor.description,
      status: (state) => state.hairColor.status,
      nextUrl: (state) => state.hairColor.nextUrl,
      sort: (state) => state.hairColor.sort,
      total: (state) => state.hairColor.total,
      displayStyle: (state) => state.hairColor.displayStyle,
    }),
  },
  methods: {
    ...mapActions("hairColor", [
      "FETCH_MORE",
      "REMOVE",
      "CHANGE_DISPLAY_STYLE",
      "SORT",
      "FETCH_ALL",
    ]),
    plural,
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/_config.scss";

.item-list {
  margin: 0;
  padding: 0;
}

.button-holder {
  text-align: left;
  padding-top: 0;

  .sort-button {
    margin-right: 10px;
    width: auto;
  }
}
</style>
